export enum PermissionKey {
  baseline = 'fd.baseline',
  canAssignUserToTrackedDeal = 'fd.list.track.assign-user',
  canBulkExportData = 'fd.customer-success.bulk-export',
  canEditDeal = 'fd.deal.edit',
  canEditFund = 'fd.fund.edit',
  canEditList = 'fd.list.edit',
  canEditPortfolioCompany = 'fd.portfolio.company.edit',
  canEditScenarios = 'fd.scenario.edit',
  canEditTransaction = 'fd.transactions.edit',
  canHidePeople = 'fd.people.hide',
  canPromoteCaptable = 'fd.captable.promote',
  canPromoteScenarios = 'fd.scenario.promote',
  canReadDataCollection = 'fd.data-collection.read',
  canSubmitCollectionSubmit = 'fd.data-collection.submit',
  canViewAppAdminPanel = 'fd.admin-panel.view',
  canViewCaptable = 'fd.captable.view',
  canViewCartaManage = 'fd.integrations.carta.read',
  canViewClientSettings = 'fd.customer-success.client-settings',
  canViewCompanyBasics = 'fd.company.basics.view',
  canViewCompanyFinancials = 'fd.company.financials.view',
  canViewDeal = 'fd.deal.read',
  canViewKpis = 'fd.kpis.view',
  canViewList = 'fd.list.read',
  canViewMetrics = 'fd.metrics.read',
  canViewMultiperiod = 'fd.portfolio.multiperiod.read',
  canViewScenarios = 'fd.scenario.view',
  canViewSecurityViews = 'fd.portfolio.views.security.*',
  canViewSensitiveMetrics = 'fd.portfolio.multiperiod.sensitivemetrics.read',
  canViewTransaction = 'fd.transactions.read',
  canViewUserAdminPanel = 'fd.user-settings.view',
  canWriteCaptable = 'fd.captable.edit',
  canWriteDataCollection = 'fd.data-collection.write',
  canWriteMultiperiod = 'fd.portfolio.multiperiod.write',
  customerSuccessAll = 'fd.customer-success.*',
  hasAnalysisModule = 'fd.analysis.*',
  hasAuditorAccess = 'fd.auditor.*',
  hasDataCollectionModule = 'fd.data-collection.*',
  hasFundProfilesModule = 'fd.fund.*',
  hasIntegrationsModule = 'fd.integrations.*',
  hasMappingsModule = 'fd.mappings.*',
  hasRestrictedColumnAccess = 'fd.column.access',
  /** Foresight staff. Gates the legal-structure mutation endpoints, which carry
   *  `@UserAccess({ permissions: [INTERNAL] })` on the API side. */
  isInternal = 'fd.internal',
  standard = 'fd.standard',
}

/** Identity flags, checked with an exact match only: a wildcard grant such as
 *  `fd.*` or `fd.data-collection.*` must never turn a user into one of these. */
export enum PersonaKey {
  managedServices = 'fd.persona.managed-services',
  respondent = 'fd.persona.respondent',
  limitedProfile = 'fd.persona.limited-profile',
  portalOnly = 'fd.persona.portal-only',
}
export function kpiCardNameToPermissionKey(componentName: string) {
  return `fd.portfolio.tile.${componentName.replace(/_/g, '-')}`;
}

export function chartNameToPermissionKey(componentName: string) {
  return `fd.portfolio.chart.${componentName.replace(/_/g, '-')}`;
}
